<template>

    <div class="simulator-box">

        <h2 class="simulator-title" :class="{loaded: cliente, 'with-animation' : carregando}">Informações Adicionais</h2>

        <div class="card-panel">

            <div class="mb-2">
                <label class="label active">Você faz uso de algum medicamento recorrente?</label>
                <div class="switch">
                    <label>
                        Não
                        <input type="checkbox" v-model="informacao_adicional.medicamento_recorrente" @change="salvar()">
                        <span class="lever"></span>
                        Sim
                    </label>
                </div>
            </div>

            <div class="input-field mb-2" v-if="informacao_adicional.medicamento_recorrente">
                <label for="qual_medicamento" class="label active">Qual?</label>
                <input @input="salvar()" type="text" class="form-control"  id="qual_medicamento" v-model="informacao_adicional.medicamento_recorrente_especifico" />
            </div>
        </div>

        <div class="card-panel">
            <label class="label active">Encontra-se em plena atividade profissional?</label>
            <div class="switch">
                <label>
                    Não
                    <input type="checkbox" v-model="informacao_adicional.plena_atividade_profissional" @change="salvar()">
                    <span class="lever"></span>
                    Sim
                </label>
            </div>
        </div>


        <div class="card-panel">
            <div class="mb-2">
                <label class="label active">Nos últimos 5 (cinco) anos foi submetido a algum tratamento médico ou cirúrgico?</label>
                <div class="switch">
                    <label>
                        Não
                        <input type="checkbox" v-model="informacao_adicional.tratamento_medico" @change="salvar()">
                        <span class="lever"></span>
                        Sim
                    </label>
                </div>
            </div>

            <div class="input-field mb-2" v-if="informacao_adicional.tratamento_medico">
                <label for="qual_medicamento" class="label active">Qual?</label>
                <input type="text" class="form-control"  id="qual_medicamento" v-model="informacao_adicional.tratamento_medico_especifico" @input="salvar()" />
            </div>
        </div>

        <div class="card-panel">

            <div class="mb-2">
                <label class="label active">Pratica esportes?</label>
                <div class="switch">
                    <label>
                        Não
                        <input type="checkbox" v-model="informacao_adicional.pratica_esporte" @change="salvar()">
                        <span class="lever"></span>
                        Sim
                    </label>
                </div>
            </div>

            <div class="input-field mb-2" v-if="informacao_adicional.pratica_esporte">
                <label for="qual_medicamento" class="label active">Quais modalidades?</label>
                <input @input="salvar()" type="text" class="form-control"  id="qual_medicamento" v-model="informacao_adicional.modalidade_esporte" />
            </div>

            <div class="input-field mb-2" v-if="informacao_adicional.pratica_esporte">
                <label for="qual_medicamento" class="label active">Com qual frequência pratica esportes?</label>
                <input @input="salvar()" type="text" class="form-control"  id="qual_medicamento" v-model="informacao_adicional.frequencia_atividade_esportiva" />
            </div>
        </div>


        <div class="card-panel">

            <div class="mb-2">
                <label class="label active">Fumante?</label>
                <div class="switch">
                    <label>
                        Não
                        <input type="checkbox" v-model="informacao_adicional.fumante" @change="salvar()">
                        <span class="lever"></span>
                        Sim
                    </label>
                </div>
            </div>

            <div class="input-field mb-2" v-if="informacao_adicional.fumante">
                <label for="fumante_frequencia_diaria" class="label active">Qual é a média de cigarros por dia?</label>
                <input @input="salvar()" type="text" class="form-control"  id="fumante_frequencia_diaria" v-model="informacao_adicional.fumante_media_diaria" />
            </div>
        </div>


        <div class="card-panel">
            <div class="input-field">
                <label class="label active">Anotações (opcional)</label>
                <input v-model="informacao_adicional.anotacoes" class="form-control"  @input="salvar()" maxlength="1500" placeholder="Digite uma anotação aqui (máximo 1500 caracteres)"/>
            </div>
        </div>


        <FooterSimulador :loading.sync="carregando" />


    </div>
</template>


<script>

import { api } from "@/helpers/api";

import InputSimulador from '@/components/common/InputSimulador.vue';
import TotalSimulador from '@/components/common/TotalSimulador.vue';
import FooterSimulador from "@/components/common/FooterSimulador.vue";

import debounce from "lodash/debounce";

import swal from 'sweetalert2';

export default {

    name: 'informacao-adicional',

    components: {FooterSimulador, TotalSimulador, InputSimulador},


    data() {
        return {
            cliente: null,
            carregando: false,
            informacao_adicional: {}
        }
    },


    async created() {

        let {id} = this.$route.params;

        let {data: {result: {data: cliente}}} = await api.get(`cliente/${id}`);

        this.informacao_adicional = {
            ...cliente.informacao_adicional,
            cliente_id: cliente.cliente_id
        };

        this.cliente = cliente;
    },

    methods: {

        salvar: debounce(async function () {


            this.carregando = true;

            try{

                await api.put('informacoes-adicionais', this.informacao_adicional);

            } finally {
                setTimeout(() => this.carregando = false, 2000)
            }



        }, 500)
    }
}
</script>


<style lang="scss" scoped>

.form-control,
.materialize-textarea{
    margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/clientes/InformacaoAdicional.vue